import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, ref, watch } from 'vue';
import { modalController } from '@ionic/vue';
import CInfiniteCalendar from '@/components/core/InfiniteCalendar/CInfiniteCalendar.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  setBeetweenDate: {
    type: Function as PropType<(between: { begin: Date; end: Date; }) => void>,
    required: true
  },
  value: {
    type: Array as PropType<Date[]>,
    required: false
  },
},
  setup(__props) {

const props = __props



const dateBetween = ref<Date[]>(props.value ? [...props.value] : []);

watch(dateBetween, value => {
  if (value?.length === 2) {
    props.setBeetweenDate({
      begin: value[0],
      end: value[1]
    });

    // Если закрывать сразу, то закрывается слишком резко, визуально не очень приятно
    setTimeout(close, 220);
  }
});

function close() {
  return modalController.dismiss();
}

let prevYScrollTop = 0;
const headerHide = ref(true);
function onCalendarScroll(offsets: { dOffsetTop: number; scrollTop: number; }) {
  const deltaY = prevYScrollTop - offsets.scrollTop;
  // Сохраняем значение с поправкой на смещение (т.к. у нас календарь с бесконечной прокруткой)
  prevYScrollTop = offsets.scrollTop + offsets.dOffsetTop;

  if (!headerHide.value && deltaY < -3) {
    headerHide.value = true;
  } else if (headerHide.value && deltaY > 3) {
    headerHide.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, {
      class: _normalizeClass({
    'c-clean-close-header': true,
    'c-choice-between-date-modal-header': true,
    'c-choice-between-date-modal-header--hide': headerHide.value,
  })
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              class: "d-close-button",
              color: "light",
              fill: "clear",
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, { name: "core-close-backgroup" })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_ion_content, { "scroll-y": false }, {
      default: _withCtx(() => [
        _createVNode(CInfiniteCalendar, {
          onCalendarScroll: onCalendarScroll,
          "is-beetween": true,
          modelValue: dateBetween.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateBetween).value = $event)),
          class: "visits-new-preentry-calendar"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer)
  ], 64))
}
}

})